import _ from './index';
import storage from 'local-storage-fallback';

export interface UserLoggedInData {
  sessionId: string;
  member: any;
}


function arrayBufferToBase64(buffer) {
  let binary = '';
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < bytes.byteLength; i++) {
    binary += String.fromCharCode(bytes[i]);
  }
  return btoa(binary);
}

function base64ToArrayBuffer(base64) {
  const binary = atob(base64);
  const len = binary.length;
  const buffer = new ArrayBuffer(len);
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < len; i++) {
    bytes[i] = binary.charCodeAt(i);
  }
  return buffer;
}

class StorageService {
  public static LOGIN_DEVICE_LOCKLESS_KEY = 'login_locklessKey';
  public static LOGIN_DEVICE_KEY = 'login_deviceKey';
  public static LOGIN_SESSION_KEY = 'login_sessionId';
  public static LOGIN_MEMBERJSON_KEY = 'login_memberJson';

  constructor() {
  }

  async isLoggedAsync(): Promise<boolean> {
    let sessionId = await storage.getItem(StorageService.LOGIN_SESSION_KEY);
    if (sessionId) {
      return true;
    }
    return false;
  }

  async setLoggedAsync(sessionId: string, member_json_string: string): Promise<void> {
    await storage.setItem(StorageService.LOGIN_SESSION_KEY, sessionId);
    await storage.setItem(StorageService.LOGIN_MEMBERJSON_KEY, member_json_string);
  }

  async updateMemberAsync(member_json_string: string): Promise<void> {
    await storage.setItem(StorageService.LOGIN_MEMBERJSON_KEY, member_json_string);
  }

  async updateSessionAsync(sessionId: string): Promise<void> {
    await storage.setItem(StorageService.LOGIN_SESSION_KEY, sessionId);
  }

  async setEntLoggedAsync(newState: boolean = true): Promise<void> {
    await storage.setItem('login_ent', JSON.stringify(newState));
  }

  async getLoggedAsync(): Promise<UserLoggedInData> {
    let sessionId = await storage.getItem(StorageService.LOGIN_SESSION_KEY);
    if (!sessionId) {
      return null;
    }
    let member_json_string = await storage.getItem(StorageService.LOGIN_MEMBERJSON_KEY);
    if (!member_json_string) {
      return null;
    }

    try {
      return {
        sessionId: sessionId,
        member: JSON.parse(member_json_string),
      };
    } catch (err) {
      await this.clearLoggedAsync();
      return null;
    }
  }

  async clearLoggedAsync(): Promise<void> {
    await storage.removeItem(StorageService.LOGIN_SESSION_KEY);
    await storage.removeItem(StorageService.LOGIN_MEMBERJSON_KEY);
  }

  /**
   * Get an ArrayBuffer key
   */
  getDeviceKey() {
    let deviceKey = storage.getItem(StorageService.LOGIN_DEVICE_KEY);
    if (deviceKey) {
      const buffer = base64ToArrayBuffer(deviceKey);
      return buffer;
    }
    return deviceKey;
  }

  getDeviceKeyBase64() {
    let deviceKey = storage.getItem(StorageService.LOGIN_DEVICE_KEY);
    if (deviceKey) {
      return deviceKey;
    }
    return deviceKey;
  }
  /**
   * return ArrayBuffer
   * @param base64
   */

  ConvertBase64StringToDeviceKey(base64:string) {
    return base64ToArrayBuffer(base64);
  }


  /**
   * Set key
   * @param obj an ArrayBuffer key
   */
  setDeviceKey(obj: any) {
    if (obj === null) {
      storage.removeItem(StorageService.LOGIN_DEVICE_KEY);
      return null;
    } else {
      if (obj instanceof ArrayBuffer) {
        //const buffer = new TextEncoder().encode(obj).buffer;
        const buffer = obj;
        const base64 = arrayBufferToBase64(buffer);
        obj = base64;
      }
      let deviceKey = storage.setItem(StorageService.LOGIN_DEVICE_KEY, obj);
      return deviceKey;
    }
  }

  /**
   * Get a String key
   */
  getDeviceLocklessKey() {
    let deviceKey = storage.getItem(StorageService.LOGIN_DEVICE_LOCKLESS_KEY);
    return deviceKey;
  }

  /**
   * Set key
   * @param obj a String Key
   */
  setDeviceLocklessKey(obj: string) {
    if (obj === null) {
      storage.removeItem(StorageService.LOGIN_DEVICE_LOCKLESS_KEY);
      return null;
    } else {
      let deviceKey = storage.setItem(StorageService.LOGIN_DEVICE_LOCKLESS_KEY, obj);
      return deviceKey;
    }
  }
}

export {StorageService}
